import React from "react";

const AboutIcon = ({ ...props }) => {
  return (
    <svg
      width="25"
      {...props}
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.6161 13V19C18.6161 19.5304 18.4054 20.0391 18.0304 20.4142C17.6553 20.7893 17.1466 21 16.6161 21H5.61615C5.08572 21 4.57701 20.7893 4.20194 20.4142C3.82686 20.0391 3.61615 19.5304 3.61615 19V8C3.61615 7.46957 3.82686 6.96086 4.20194 6.58579C4.57701 6.21071 5.08572 6 5.61615 6H11.6161"
        stroke="#071441"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.6161 3H21.6161V9"
        stroke="#071441"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6161 14L21.6161 3"
        stroke="#071441"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default AboutIcon;
